// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3D_-J","dragIcon":"Choice_dragIcon__2YZIA","left":"Choice_left__1xDgr","input":"Choice_input__25BWk"};